export const BODY_PARTS = {
  BRAIN: 'brain',
  NECK: 'neck',
  BONE: 'bone',
  LUNG: 'lung',
  LIVER: 'liver',
  LYMPHNODE: 'lymph-node',
  ADRENALGLAND: 'adrenal-gland',
  PLEURA: 'pleura',
  PLEURALEFFUSION: 'pleural-effusion',
  OTHERS: 'others',
};

export const TRACKING_TYPES = {
  TARGET: 'target',
  NONTARGET: 'non-target',
  NEW: 'new',
  NEW_TARGET: 'new-lesion-target',
  NEW_NONTARGET: 'new-lesion-non-target',
  NOTINCLUDED: 'not-included',
  NONE: 'none',
  ISOLATED: 'isolated',
};

export const OVERALL_RESPONSE = {
  COMPLETE_RESPONSE: 'CR',
  PARTIAL_RESPONSE: 'PR',
  STABLE_DISEASE: 'SD',
  PSEUDO_PROGRESSIVE_DISEASE: 'Pseudo-PD',
  PROGRESSIVE_DISEASE: 'PD',
  NOT_EVALUABLE: 'NE',
  NONE: 'NED',
  iCR: 'iCR',
  iPR: 'iPR',
  iSD: 'iSD',
  iUPD: 'iUPD',
  iCPD: 'iCPD',
};

export const TARGET_RESPONSE = {
  COMPLETE_RESPONSE: 'CR',
  PARTIAL_RESPONSE: 'PR',
  STABLE_DISEASE: 'SD',
  PROGRESSIVE_DISEASE: 'PD',
  NOT_EVALUABLE: 'NE',
  NONE: 'NED',
  iCR: 'iCR',
  iPR: 'iPR',
  iSD: 'iSD',
  iUPD: 'iUPD',
  iCPD: 'iCPD',
};

export const NON_TARGET_RESPONSE = {
  COMPLETE_RESPONSE: 'CR',
  NON_PROGRESSIVE_RESPONSE: 'Non-CR/Non-PD',
  PROGRESSIVE_DISEASE: 'PD',
  NOT_EVALUABLE: 'NE',
  NONE: 'NED',
  iCR: 'iCR',
  iNN: 'Non-iCR/Non-iUPD',
  iUPD: 'iUPD',
  iCPD: 'iCPD',
};

export const NEW_LESION_RESPONSE = {
  PRESENT: 'Unequivocal',
  ABSENT: 'Absent',
  UNCONFIRMED: 'Equivocal',
  EQUIVOCAL: 'Equivocal',
  UNEQUIVOCAL: 'Unequivocal',
  NOT_EVALUABLE: 'NE',
  NONE: 'NED',
  iCR: 'iCR',
  iPR: 'iPR',
  iSD: 'iSD',
  iNN: 'Non-iCR/Non-iUPD',
  iUPD: 'iUPD',
  iCPD: 'iCPD',
};

export const MEASUREMENT_TECHNIQUE = {
  UNIDIMENSIONAL: 'UNIDIMENSIONAL',
  BIDIMENSIONAL: 'BIDIMENSIONAL',
  VOLUMETRIC: 'VOLUMETRIC',
};

export const STEROIDS_USE = {
  NONE: 'None',
  DECREASED: 'Decreased',
  STABLE: 'Stable',
  INCREASED: 'Increased',
  NOT_APPLICABLE: 'N/A',
};

export const CLINICAL_STATUS = {
  WORSE: 'Worse',
  STABLE: 'Stable',
  IMPROVED: 'Improved',
  NOT_APPLICABLE: 'N/A',
};

export const BRAIN_LOCATION = {
  L_Frn: 'Left Frontal',
  R_Frn: 'Right Frontal',
  L_Temp: 'Left Temporal',
  R_Temp: 'Right Temporal',
  L_Par: 'Left Parietal',
  R_Par: 'Right Parietal',
  L_Occ: 'Left Occipital',
  R_Occ: 'Right Occipital',
  L_Cere: 'Left Cerebellum',
  R_Cere: 'Right Cerebellum',
  BS: 'Brainstem',
  L_Caud: 'Left Caudate',
  R_Caud: 'Right Caudate',
  L_Puta: 'Left Putamen',
  R_Puta: 'Right Putamen',
  L_Thal: 'Left Thalamus',
  R_Thal: 'Right Thalamus',
  L_GP: 'Left Globus Pallidus',
  R_GP: 'Right Globus Pallidus',
};

export function getMeasurementTechniques() {
  return [
    ['BIDIMENSIONAL', 'Bidimensional'],
    ['VOLUMETRIC', 'Volumetric'],
  ];
}

export function getMeasurementLesionTypes(guideline) {
  switch (guideline) {
    case 'iRECIST': {
      return [
        { id: 'target', label: 'Target' },
        { id: 'non-target', label: 'Non-target' },
        { id: 'new-lesion-target', label: 'NEW(Target)' },
        { id: 'new-lesion-non-target', label: 'NEW(Non-Target)' },
        { id: 'not-included', label: '--------' },
      ];
    }
    default: {
      return [
        { id: 'target', label: 'Target' },
        { id: 'non-target', label: 'Non-target' },
        { id: 'new', label: 'New' },
        { id: 'not-included', label: '--------' },
      ];
    }
  }
}

export function getLesionTypes(guideline) {
  switch (guideline) {
    case 'iRECIST': {
      return [
        { id: 'target', label: 'T' },
        { id: 'non-target', label: 'NT' },
        { id: 'new-lesion-target', label: 'NEW(T)' },
        { id: 'new-lesion-non-target', label: 'NEW(NT)' },
      ];
    }
    default: {
      return [
        { id: 'target', label: 'Target' },
        { id: 'non-target', label: 'Non-target' },
        { id: 'new', label: 'New' },
      ];
    }
  }
}

export function getBodyParts() {
  return [
    ['all', 'Whole Body'],
    ['brain', 'Brain'],
    ['neck', 'Neck'],
    ['liver', 'Liver'],
    ['lung', 'Lung'],
    ['lymph-node', 'Lymph Node'],
    ['adrenal-gland', 'Adrenal Gland'],
    ['pleural-effusion', 'Pleural Effusion'],
  ];
}

export function getTrackingTypes(guideline) {
  switch (guideline) {
    case 'iRECIST': {
      return [
        ['all', 'All Lesions'],
        ['measurable', 'All Measurables'],
        ['target', 'Target Lesions'],
        ['non-target', 'Non-target Lesions'],
        ['new-lesion-target', 'New Lesion Targets'],
        ['new-lesion-non-target', 'New Lesion Non-targets'],
        ['selected', 'Selected Lesion'],
      ];
    }
    default: {
      return [
        ['all', 'All Lesions'],
        ['measurable', 'All Measurables'],
        ['target', 'Target Lesions'],
        ['non-target', 'Non-target Lesions'],
        ['new', 'New Lesions'],
        ['selected', 'Selected Lesion'],
      ];
    }
  }
}

export function getResponseTypes(guideline) {
  switch (guideline) {
    case 'iRECIST': {
      return {
        TARGET_RESPONSE: [
          { value: 'iCR', label: 'iCR' },
          { value: 'iPR', label: 'iPR' },
          { value: 'iSD', label: 'iSD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NON_TARGET_RESPONSE: [
          { value: 'iCR', label: 'iCR' },
          { value: 'Non-iCR/Non-iUPD', label: 'Non-iCR/Non-iUPD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NEW_LESION_TARGET_RESPONSE: [
          { value: 'iCR', label: 'iCR' },
          { value: 'iPR', label: 'iPR' },
          { value: 'iSD', label: 'iSD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        NEW_LESION_NON_TARGET_RESPONSE: [
          { value: 'iCR', label: 'iCR' },
          { value: 'Non-iCR/Non-iUPD', label: 'Non-iCR/Non-iUPD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        USE_OF_STEROIDS: [{ value: 'N/A', label: 'N/A' }],
        CLINICAL_STATUS: [
          { value: 'N/A', label: 'N/A' },
          { value: 'Worse', label: 'Worse' },
          { value: 'Stable', label: 'Stable' },
          { value: 'Improved', label: 'Improved' },
        ],
        OVERALL_RESPONSE: [
          { value: 'iCR', label: 'iCR' },
          { value: 'iPR', label: 'iPR' },
          { value: 'iSD', label: 'iSD' },
          { value: 'Non-iCR/Non-iUPD', label: 'Non-iCR/Non-iUPD' },
          { value: 'iUPD', label: 'iUPD' },
          { value: 'iCPD', label: 'iCPD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
      };
    }
    case 'RECIST11': {
      return {
        TARGET_RESPONSE: [
          { value: 'CR', label: 'CR' },
          { value: 'PR', label: 'PR' },
          { value: 'SD', label: 'SD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NON_TARGET_RESPONSE: [
          { value: 'CR', label: 'CR' },
          { value: 'Non-CR/Non-PD', label: 'Non-CR/Non-PD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NEW_LESION_RESPONSE: [
          { value: 'Unequivocal', label: 'Unequivocal' },
          { value: 'Equivocal', label: 'Equivocal' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        USE_OF_STEROIDS: [{ value: 'N/A', label: 'N/A' }],
        CLINICAL_STATUS: [{ value: 'N/A', label: 'N/A' }],
        OVERALL_RESPONSE: [
          { value: 'CR', label: 'CR' },
          { value: 'PR', label: 'PR' },
          { value: 'SD', label: 'SD' },
          { value: 'Non-CR/Non-PD', label: 'Non-CR/Non-PD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
      };
    }
    default: {
      return {
        TARGET_RESPONSE: [
          { value: 'CR', label: 'CR' },
          { value: 'PR', label: 'PR' },
          { value: 'SD', label: 'SD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NON_TARGET_RESPONSE: [
          { value: 'CR', label: 'CR' },
          { value: 'Non-CR/Non-PD', label: 'Non-CR/Non-PD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
        NEW_LESION_RESPONSE: [
          { value: 'Unequivocal', label: 'Unequivocal' },
          { value: 'Equivocal', label: 'Equivocal' },
          { value: 'Absent', label: 'Absent' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED', disabled: true },
        ],
        USE_OF_STEROIDS: [
          { value: 'N/A', label: 'N/A' },
          { value: 'None', label: 'None' },
          { value: 'Decreased', label: 'Decreased' },
          { value: 'Stable', label: 'Stable' },
          { value: 'Increased', label: 'Increased' },
        ],
        CLINICAL_STATUS: [
          { value: 'N/A', label: 'N/A' },
          { value: 'Worse', label: 'Worse' },
          { value: 'Stable', label: 'Stable' },
          { value: 'Improved', label: 'Improved' },
        ],
        OVERALL_RESPONSE: [
          { value: 'CR', label: 'CR' },
          { value: 'PR', label: 'PR' },
          { value: 'SD', label: 'SD' },
          { value: 'Non-CR/Non-PD', label: 'Non-CR/Non-PD' },
          { value: 'PD', label: 'PD' },
          { value: 'NE', label: 'NE' },
          { value: 'NED', label: 'NED' },
        ],
      };
    }
  }
}
